import React, { useState, useEffect } from "react";
import { deleteComment, getCommentData } from "../utils/commentFunction";
import "../Css/CommentBoard.css";
import AdminContent from "./AdminContent";
import { Button } from "semantic-ui-react";
function Comment({ aid, cid }) {
  const [data, setData] = useState();
  const [isBusy, setIsBusy] = useState(true);
  useEffect(() => {
    if (cid != "")
      getCommentData(aid, cid).then((res) => {
        console.log(res.data());
        setData(res.data());
        setIsBusy(false);
      });
  }, []);

  function handleDelete() {
    deleteComment(cid).then((res) => {
        setIsBusy(true);
    });
  }

  if (isBusy) {
    return <></>
  } else
    return (
      <>
        <div className="cb-comment-container">
          {/* 頭貼 */}
          <img src={data?.photoURL} className="cb-comment-avator"></img>
          {/* 內文 */}
          <textarea
            readOnly
            className="cb-textarea"
            value={data?.context}
          ></textarea>

          {/* owner操作 */}
          <AdminContent>
            <div className="cb-comment-btngroup">
              <Button
                inverted
                color="red"
                onClick={() => {
                  handleDelete();
                }}
              >
                Delete
              </Button>
            </div>
          </AdminContent>
        </div>        
      </>
    );
}

export default Comment;
